import { actions } from './insurance_company_report/actions'
import { getters } from './insurance_company_report/getters'
import { state } from './insurance_company_report/state'
import { mutations } from './insurance_company_report/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}